import { render, staticRenderFns } from "./userdata.vue?vue&type=template&id=13790700&scoped=true&"
import script from "./userdata.vue?vue&type=script&lang=js&"
export * from "./userdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13790700",
  null
  
)

export default component.exports